'use es6';

import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { getCanonicalAppContext } from '../../selectors/app';
import { getFullLocationUrl } from '../../utils/urls';
import { ProfileCard } from './ProfileCard';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultCard = ({
  onClick,
  result,
  width
}) => {
  const canonicalAppContext = useSelector(getCanonicalAppContext);
  const isPrerender = getIsPrerenderUserAgent();
  const history = useHistory();
  const {
    description,
    logoUrl,
    name,
    partnerType,
    reviewSummary,
    slug,
    tier
  } = result;
  const renderedProfileCard = /*#__PURE__*/_jsx(Flex, {
    inlineSize: width,
    blockSize: "100%",
    align: "stretch",
    children: /*#__PURE__*/_jsx(ProfileCard, {
      description: description,
      logoUrl: logoUrl,
      name: name,
      partnerType: partnerType,
      reviewSummary: reviewSummary,
      tier: tier
    })
  });
  const pathname = `/${slug}`;
  if (isPrerender) {
    return /*#__PURE__*/_jsx(Link, {
      "data-test-id": "storefront-result-card",
      "aria-label": unescapedText('ecosystem-marketplace-solutions-ui.storefront.results.resultsCard.accessibleLabel', {
        name
      }),
      onClick: onClick,
      use: "unstyled",
      href: getFullLocationUrl({
        pathname
      }, canonicalAppContext),
      children: renderedProfileCard
    });
  }
  return /*#__PURE__*/_jsx(RouterLink, {
    "data-test-id": "storefront-result-card",
    "aria-label": unescapedText('ecosystem-marketplace-solutions-ui.storefront.results.resultsCard.accessibleLabel', {
      name
    }),
    onClick: onClick,
    use: "unstyled",
    to: {
      pathname,
      state: {
        // used in the ProfileHeader breadcrumb
        fromHomepage: history.location && history.location.pathname === '/'
      }
    },
    children: renderedProfileCard
  });
};
export default ResultCard;